import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetReportAllFailed,
  actGetReportAllSuccess,
  MASTER_GET_REPORT_ALL,
} from '../../actions/report-all'
import { apiGetListReportAll } from '../../apis/report-all'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetList(action) {
  try {
    const response = yield call(apiGetListReportAll, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data,
        total: response.data?.length,
      }
      yield put(actGetReportAllSuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetReportAllFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(MASTER_GET_REPORT_ALL, doGetList)
}
